var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',_vm._g(_vm._b({attrs:{"headers":_vm.questionHeaders,"items":_vm.questions},scopedSlots:_vm._u([{key:"top",fn:function(){return [_vm._t("top")]},proxy:true}],null,true)},'v-data-table',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }